
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/crossword/[date]",
      function () {
        return require("private-next-pages/games/crossword/[date]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/crossword/[date]"])
      });
    }
  